import axios from "axios";

export const state = {
    consultationpatients: [],
};

export const getters = {
    consultationpatients: state => state.consultationpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.consultationpatients = newValue
    },
};

export const actions = {
    fetchConsultationPatients({ commit }) {
        axios.get('/consultationpatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterConsultationPatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterconsultationpatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
